// components/ui/product-addon-selector.jsx
import React from "react";

const ProductAddonSelector = ({ options, onOptionSelect, selectedOption }) => {
  if (!options || options.length === 0) return null;

  return (
    <div className="mt-2 mb-4">
      <div className="space-y-2">
        {options.map((option) => (
          <label
            key={option}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <input
              type="radio"
              name="addon"
              value={option}
              checked={selectedOption === option}
              onChange={() => onOptionSelect(option)}
              className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
            />
            <span className="text-sm text-gray-700">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ProductAddonSelector;
